import * as React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import SendIcon from '@material-ui/icons/Send';
import InfoOutlineIcon from '@material-ui/icons/InfoOutline';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Snackbar from '@material-ui/core/Snackbar';
import { Tooltip, DialogActions } from '@material-ui/core';
import { LinearProgress } from '@material-ui/core';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader'

import './PublishNewsPanel.scss';
import gql from 'graphql-tag';
import { client as clientGql } from "src";
import { ApolloConsumer } from 'react-apollo';
import { Query } from 'react-apollo';
import { NumberLessBRL } from '../../../services';
import * as Moment from 'moment';
import { QueryFilter, QUERY_FILTER_BESTSELLING } from 'src/component/shared';
import { ACCESS_DASHBOARD } from '../../shared/layout/products/Dashboard';
import { DialogImportPartnerData } from '../shared/component/DialogImportPartnerData';

// tslint:disable-next-line:no-empty-interface
export interface ITableAnalyticalPros {
    endDate: any,
    initialDate: any,
    changeDate(initDate:any, finalDate:any):void,
}

export interface ITableAnalytical {
    canDoImport: boolean,
    categories?: any,
    count: number,
    dialogExportOpen: boolean,
    dialogImportPartnerDataOpen: boolean,
    endDate: any,
    groups?: any,
    initialDate: any,
    limit: number,
    offset: number,
    openSeeStoresDialig: boolean,
    openSnack: boolean,
    page: number,
    rows?: any,
    snackMessage: string,
    tab: number,
}

const QUERY_PUBLISH_NEWS_PANEL_DATA = gql`
    query publishNewsPanel($customFilter:  PublishNewsPanelFilter) {
        publishNewsPanel(publishNewsPanelFilter: $customFilter) {
            sku
            description
            publisher
            volume
        }
    }
`;

const QUERY_FIND_CATEGORY = gql`
    query publishNewsPanel {
        publishNewsCategories {
            id,
            category
        }
    }
`;

const QUERY_FIND_STORES = gql`
    query publishNewsPanel {
        publishNewsEconomicGroups {
            id,
            grupo,
            stores {
                name,
                state
            }
        }
    }
`;

const QUERY_UPLOAD_PARTNERS_SALES = gql`
  mutation publishNewsPanel($customFilter:  PublishNewsPartnerFile) {
    publishNewsUploadPartnerSales(publishNewsPartnerFile: $customFilter)
  }
`;

const QUERY_FILE_REPORT = gql`
    query publishNewsPanel($customFilter:  PublishNewsPanelFilter) {
        publishNewsFileReport(publishNewsPanelFilter: $customFilter)
    }
`;

const QUERY_ADDED_PARTNERS_FILE_REPORT = gql`
query publishNewsPanel($customFilter:  PublishNewsPanelFilter) {
    publishNewsAddedPartnersFileReport(publishNewsPanelFilter: $customFilter)
}
`;
  
function LinkTab(props: any) {
    return (
        // tslint:disable-next-line:jsx-no-lambda
        <Tab component="a" onClick={event => event.preventDefault()} {...props} />
    );
}

export class TableAnalytical extends React.Component<ITableAnalyticalPros, ITableAnalytical> {

    private lockFileRequest: boolean = false;

    constructor(props: ITableAnalyticalPros) {
        super(props);
        this.state = {
            canDoImport: false,
            categories: [],
            count: 30,
            dialogExportOpen: false,
            dialogImportPartnerDataOpen: false,
            endDate: undefined,
            groups: [],
            initialDate: undefined,
            limit: 30,
            offset: 0,
            openSeeStoresDialig: false,
            openSnack: false,
            page: 0,
            rows: [],
            snackMessage: "",
            tab: 0,
        }
        this.handleSnackClose = this.handleSnackClose.bind(this);
        this.requestByDate = this.requestByDate.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleCloseSeeStores = this.handleCloseSeeStores.bind(this);
        this.handleClickSeeStores = this.handleClickSeeStores.bind(this);
        this.openSnackMessage = this.openSnackMessage.bind(this);
    }

    public componentWillMount () {
        clientGql.query({
            query: QUERY_FIND_CATEGORY
        }).then((response) => {
            this.changeCategoriesList(response);
        });

        clientGql.query({
            query: QUERY_FIND_STORES
        }).then((response) => {
            this.changeGroupList(response);
        });

        const finalDate = Moment().format('YYYY-MM-DD');
        const initDate = Moment().subtract(7, "days").format('YYYY-MM-DD');
        this.setState({
            endDate: finalDate,
            initialDate: initDate,
        });

        this.userCanDoImport().then(result => {
            this.setState({
                canDoImport: result
            })
        });
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "category": this.state.tab,
                "endDate": this.state.endDate,
                "initialDate": this.state.initialDate,
            }
        };
  
        return (
            <Query query={QUERY_FILTER_BESTSELLING} notifyOnNetworkStatusChange={true}>
                {({ loading: loadingC, error: errorC, data: cache, client: clientC, refetch: refetchC}) => {
                    return (
                        <div className="panelPublishNewsBody" >
                            <Dialog
                                open={this.state.openSeeStoresDialig}
                                onClose={this.handleCloseSeeStores}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle>{"Lojas que compõem o relatório"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <List className="stores-list" subheader={<li />}>
                                            {this.state.groups.map((group: any) => (
                                                <li key={`section-${group.id}`}>
                                                    <ul>
                                                        <ListSubheader className="group-name">{ group.grupo}</ListSubheader>
                                                        {group.stores.map((store: any) => (
                                                            <ListItem key={`item-${group.id}-${store.name}`} className="store-name">
                                                                <ListItemText primary={`${store.name} - ${store.state}`} />
                                                            </ListItem>
                                                        ))}
                                                    </ul>
                                                </li>
                                            ))}
                                        </List>
                                    </DialogContentText>
                                </DialogContent>
                            </Dialog>
                            <Snackbar
                                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                open={this.state.openSnack}
                                onClose={this.handleSnackClose}
                                ContentProps={{
                                'aria-describedby': 'message-id',
                                }}
                                message={<span id="message-id">{this.state.snackMessage}</span>}
                            />
                            <AppBar position="static" style={{ backgroundColor: '#FFFF' }}>
                                <Tabs fullWidth={true} value={this.state.tab} onChange={this.handleChangeTab} centered={true} 
                                    textColor="primary" indicatorColor="primary">

                                    <LinkTab label="Geral" href="geral" value={0} />
                                    {
                                        this.state && this.state.categories ? this.state.categories.map((item: any, key: number) => {
                                            return (
                                                <LinkTab key={key} label={item.category} href={item.category} value={item.id} />
                                            );
                                        }):null
                                    }
                                </Tabs>
                            </AppBar>
                            <Paper className="analytical-panel">
                                <Grid container={true} className="analytical-header">
                                    <Grid item={true} xs={6}>
                                        <form onSubmit={this.requestByDate}>
                                            <div className="analytical-date">
                                                <TextField
                                                    defaultValue={this.state.initialDate}
                                                    id="initialDate"
                                                    label="Data inicial"
                                                    type="date"
                                                    required={true}
                                                    InputLabelProps={{
                                                    shrink: true,
                                                    }}
                                                />
                                            </div>

                                            <TextField
                                                defaultValue={this.state.endDate}
                                                id="endDate"
                                                label="Data final"
                                                type="date"
                                                required={true}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <IconButton type="submit"  color="primary" >
                                                <Tooltip title="Pesquisar">
                                                    <SendIcon/>
                                                </ Tooltip>
                                            </IconButton>
                                        </form>
                                    </Grid>
                                    <Grid item={true} xs={4} className="grid-see-stores">
                                        {this.state.groups.length > 0 && 
                                            <Button variant="outlined" color="primary" className="see-stores" onClick={this.handleClickSeeStores}>
                                                <InfoOutlineIcon />
                                                Lojas que compõem o relatório
                                            </Button>
                                        }
                                    </Grid>
                                    <Grid item={true} xs={2}>
                                        <ApolloConsumer>
                                            {clientF => (
                                                <div>
                                                    {this.state.canDoImport && <IconButton
                                                        color="primary"
                                                        className="upload-file-button"
                                                        onClick={this.handleDialogImportPartnerDataOpen.bind(this, clientF)}>
                                                        <Tooltip title="Importar dados de terceiros">
                                                            <CloudUploadIcon />
                                                        </Tooltip>
                                                    </IconButton>}
                                                    <IconButton
                                                        color="primary"
                                                        className="download-button"
                                                        onClick={this.handleDialogExportOpen.bind(this, clientF, QueryFilter.getFilterBestselling(clientC, jsonFilter, [], false))}
                                                    >
                                                        <Tooltip title="Exportar">
                                                            <GetAppIcon/>
                                                        </ Tooltip>
                                                    </IconButton>

                                                    <Dialog
                                                        open={this.state.dialogExportOpen}
                                                        onClose={this.handleDialogExportClose}
                                                        aria-labelledby="economic-group-dialog-title"
                                                        aria-describedby="alereconomic-group-dialog-description"
                                                        className="filter-dialog"
                                                        disableBackdropClick={false}
                                                        disableEscapeKeyDown={false}
                                                    >
                                                        <DialogTitle className="filter-dialog-title" id="economic-group-dialog-title">
                                                            {"Exportação dos Mais Vendidos Publish News"}
                                                        </DialogTitle>
                                                        <DialogActions>
                                                            <Button onClick={this.handleDialogExportClose} color="secondary">
                                                                Cancelar
                                                            </Button>
                                                            <Button onClick={this.requestSimpleExport.bind(this, clientF, jsonFilter)} color="primary" autoFocus={true}>
                                                                Bookinfo
                                                            </Button>
                                                            <Button onClick={this.requestAddedPartnersDataExport.bind(this, clientF, jsonFilter)} color="primary" autoFocus={true}>
                                                                Bookinfo + Parceiros
                                                            </Button>
                                                        </DialogActions>
                                                    </Dialog>

                                                    <DialogImportPartnerData 
                                                        clientF={clientF}
                                                        isOpened={this.state.dialogImportPartnerDataOpen}
                                                        queryUpload={QUERY_UPLOAD_PARTNERS_SALES}
                                                        handleDialogImportPartnerDataClose={this.handleDialogImportPartnerDataClose} 
                                                        openSnackMessage={this.openSnackMessage}
                                                    />
                                                </div>
                                            )}
                                        </ApolloConsumer>
                                    </Grid>
                                </Grid>
                            
                                <Query query={QUERY_PUBLISH_NEWS_PANEL_DATA} variables={QueryFilter.getFilterBestselling(clientC, jsonFilter, [], false)}>
                                    {({ loading, error, data, client, refetch}) => {
                                        return (
                                            <div>
                                                {this.informationGridToRend(data,loading)}
                                            </div>                                
                                        );
                                    }}
                                </Query>
                            </Paper>
                        </div>
                    );
                }}
            </Query>
        );
    }

    public handleSnackClose(ev: any) {
        this.setState({
            openSnack: false,
        });
    }

    public requestByDate(ev: any) {
        ev.preventDefault();

        const diference = Moment(ev.target.endDate.value,'YYYY-MM-DD')
            .diff(Moment(ev.target.initialDate.value, 'YYYY-MM-DD'), 'days');

        if(diference<=90) {
            this.props.changeDate(ev.target.initialDate.value, ev.target.endDate.value);
            this.setState({
                endDate: ev.target.endDate.value,
                initialDate: ev.target.initialDate.value,
            });
        } else {
            this.setState({
                openSnack: true,
                snackMessage: "O intervalo limite de data para pesquisa é de 90 dias",
            });
        }
    }

    public handleClickSeeStores() {
        this.setState({ openSeeStoresDialig: true });
    }

    public handleCloseSeeStores () {
        this.setState({ openSeeStoresDialig: false });
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private informationGridToRend (data:any, loading:any) {
        return (
            <div>
                <div className="analytical-table">
                    {loading ? <LinearProgress /> :<Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Ordem</TableCell>
                                <TableCell>ISBN</TableCell>
                                <TableCell>Título</TableCell>
                                <TableCell>Editora</TableCell>
                                <TableCell>Volume</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                data && data.publishNewsPanel ? this.paginacaoVirtual(data.publishNewsPanel).map((row: any, key: number) => {
                                    return (
                                        <TableRow key={key}>
                                            <TableCell className="padding-left">{ 1 + key + (this.state.page * this.state.limit) }</TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.sku}
                                            </TableCell>
                                            <TableCell>{row.description}</TableCell>
                                            <TableCell>{row.publisher}</TableCell>
                                            <TableCell>{NumberLessBRL(row.volume)}</TableCell>
                                        </TableRow>
                                    );
                                }):<div/>
                            }
                        </TableBody>
                    </Table>}
                </div>

                {
                    loading ? (
                        <div className="loading-margin" />
                    ) : (
                        <TablePagination
                            component="div"
                            page={this.state.page}
                            count={data && data.publishNewsPanel ? data.publishNewsPanel.length : this.state.count}
                            rowsPerPage={this.state.limit}
                            rowsPerPageOptions={[30,50,100]}
                            backIconButtonProps={{
                                'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Next Page',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    )
                }
            </div>
        );
    }

    private handleChangePage(ev: any, pageParam: number) {

        if (pageParam <= this.state.page) {
            this.setState({
                offset: pageParam * this.state.limit <= 0 ? 0 : pageParam * this.state.limit,
                page: pageParam,
            });
        } else {
            this.setState({
                offset: pageParam * this.state.limit,
                page: pageParam,
            });
        }
    }


    private handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>) {
        const newLimit = parseInt(event.target.value, 10);
        if(event.target.value) {
            this.setState({
                limit: newLimit,
                offset: this.state.page * newLimit,
            });
        }
    }

    private paginacaoVirtual = (data: any[]) => {
        const start = this.state.offset;
        const end = start + this.state.limit;
        return data.slice(start, end);
    }

    private handleChangeTab = (event: any, value: any) => {
        this.setState({
            offset: 0,
            page: 0, 
            tab: value,
        });
    };

    private changeCategoriesList(response:any) {
        if(response && response.data && response.data.publishNewsCategories) {
            this.setState({
                categories: response.data.publishNewsCategories
            });
        }
    };

    private changeGroupList(response: any) {
        if(response && response.data && response.data.publishNewsEconomicGroups) {
            this.setState({
                groups: response.data.publishNewsEconomicGroups
            });
        }
    }

    private openSnackMessage (message:string) {
        this.setState({
            openSnack: true,
            snackMessage: message,
        });
    }

    /**
     * Metodos para a importação de dados de vendas dos parceiros Publish News
     * 
     * INICIO
     */
    private handleDialogImportPartnerDataOpen = () => {
        this.setState({dialogImportPartnerDataOpen: true});
    };

    private handleDialogImportPartnerDataClose = () => {
        this.setState({dialogImportPartnerDataOpen: false});
    };

    // Verifica se o usuário tem permissão de importar dados
    private async userCanDoImport () {
        return clientGql.query({
          query: ACCESS_DASHBOARD,
          variables: {}
        }).then((result:any) => {
            return result.data && result.data.dashBoard && result.data.dashBoard.array_profiles && result.data.dashBoard.array_profiles.includes(67);
        });
    }
    /**
     * Metodos para a importação de dados de vendas dos parceiros Publish News
     * 
     * FIM
     */

    private handleDialogExportOpen = () => {
        this.setState({ dialogExportOpen: true });
    };
  
    private handleDialogExportClose = () => {
        this.setState({ dialogExportOpen: false });
    };

    private requestSimpleExport(client: any, filter: any) {
        this.requestFile(client, filter, QUERY_FILE_REPORT);
    }
    
    private requestAddedPartnersDataExport(client: any, filter: any) {
        this.requestFile(client, filter, QUERY_ADDED_PARTNERS_FILE_REPORT);
    }

    private requestFile(client: any, filter: any, gqlQuery:any) {
        if (this.lockFileRequest) {
            this.setState({
                dialogExportOpen: false,
                openSnack: true,
                snackMessage: "Há um relatório sendo preparado para download, aguarde",
            });
            return;
        }
    
        const deepFilter = JSON.parse(JSON.stringify(filter));
        delete deepFilter.customFilter.limit;
        delete deepFilter.customFilter.offset;
    
        this.lockFileRequest = true;
        this.setState({
            dialogExportOpen: false,
            openSnack: true,
            snackMessage: "O relatório está sendo preparado para download",
        });
    
        client.query({
            fetchPolicy: 'network-only',
            query: gqlQuery,
            variables: deepFilter
        }).then(() => {
            this.lockFileRequest = false;
        });
    }
}


// WEBPACK FOOTER //
// ./src/component/panel/publish-news/TableAnalytical.tsx